import React from 'react'

function CancellationPolicy() {
  return (
    <div className="privacy-policy">
    <div className="privacy-policy-in">

    <h1>Order Cancellation Policy</h1>
        
        <h2>No Cancellations After Order Placement</h2>
        <p>Once an order is placed, it cannot be canceled. We process all orders immediately to ensure prompt delivery, and therefore, cancellations are not permitted.</p>

        <h2>No Modifications Allowed</h2>
        <p>Once the order is placed, no changes or modifications (such as product additions, changes in address, or updates to the order) are allowed. Please ensure all details are accurate before placing your order.</p>

        <h2>Exceptions</h2>
        <p>In rare circumstances, such as if the item is out of stock or a pricing error occurs, we reserve the right to cancel the order. In such cases, the full amount will be refunded to you.</p>
  
        <h2>Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>
    {/* <p>Phone: +919513280298</p> */}
        </div>
        </div>

)
}

export default CancellationPolicy